import { ascend, filter, find, path, propEq, sortWith, values } from 'ramda';
import { getLoadingState } from 'reactApp/modules/loading/loading.selectors';
import { createSelector } from 'reselect';
import { promoTariffsStart } from './promoTariffs.module';

const getState = (state) => state.promoTariffs;
const getList = (state) => state.promoTariffs.list;
const isDiscount = (item) => item.type === 'discount';
const isQuota = (item) => item.type === 'quota';
const isRustore = (item) => item.type === 'rustore';
const getProductId = (state, productId) => productId;
const getId = (state, id) => id;

export const getRawList = (state) => getState(state).rawList;
export const isPromoTariffsLoaded = (state) => getState(state).isLoaded;

export const getPromoById = createSelector(getList, getId, (list, id) => path([id], list));

// discount
export const getDiscountPromo = createSelector(getList, filter(isDiscount));

export const sortDiscountPromoBySpace = createSelector(getDiscountPromo, (list) =>
    sortWith([ascend(path(['unlocked', 'space', 'original'])), ascend(path(['id']))], values(list))
);

export const getDiscountByProductId = createSelector(getDiscountPromo, getProductId, (list, productId) =>
    find(propEq('productId', productId), values(list))
);

// показываем подписки с типом quota и подписки рустора, тк они не приходят в ручке /subs/list
const getPromoListToShow = createSelector(
    getList,
    filter((item) => isQuota(item) || isRustore(item))
);

export const sortPromoListToShow = createSelector(getPromoListToShow, (list) =>
    sortWith([ascend(path(['space', 'original'])), ascend(path(['id']))], values(list))
);

export const getPromoTarifsLoadingState = (state) => getLoadingState(state, [promoTariffsStart.type]);
